import { IconButton } from "@mui/material";
import React from "react";

interface ByzMuiIconButtonProps extends React.ComponentProps<typeof IconButton> {
  hoverColor?: string;
}

export const ByzMuiIconButton: React.FC<ByzMuiIconButtonProps> = ({
  hoverColor = "#2979C3",
  sx,
  children,
  ...rest
}) => {
  return (
    <IconButton
      {...rest}
      sx={{
        '&:hover': {
          backgroundColor: 'transparent !important',
          '& .MuiSvgIcon-root': {
            color: hoverColor,
          },
          '& svg path': {
            fill: hoverColor,
          },
        },
        ...sx,
      }}
    >
      {children}
    </IconButton>
  );
};
